/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { exportTargetMappingDelete } from '../../axios/exportTargetMappingDelete'
import type {
	ExportTargetMappingDeleteError,
	ExportTargetMappingDeletePathParams,
	ExportTargetMappingDeleteResponse,
} from '../../types/ExportTargetMappingDelete'

export const exportTargetMappingDeleteMutationKey = () => [{ url: '/export-target-mappings/:mapping' }] as const

export type ExportTargetMappingDeleteMutationKey = ReturnType<typeof exportTargetMappingDeleteMutationKey>

export type ExportTargetMappingDeleteVariables = {
	mapping: ExportTargetMappingDeletePathParams['mapping']
}

/** @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::delete */
export function useExportTargetMappingDelete<TContext = unknown>(
	options?: UseMutationOptions<
		ExportTargetMappingDeleteResponse,
		AxiosError<ExportTargetMappingDeleteError>,
		ExportTargetMappingDeleteVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: exportTargetMappingDeleteMutationKey(),
		mutationFn: ({ mapping }: ExportTargetMappingDeleteVariables) =>
			exportTargetMappingDelete(mapping, config).then(res => res.data),
		...options,
	})
}
